import React from 'react'
import { withRouter } from 'react-router'
import { Row, Col, Typography, Form, Button, Input, Checkbox, Modal, Space, message } from 'antd'
import { reqRegister, reqCaptcha } from '../../api'

const { Title } = Typography

class Register extends React.Component {
    state = {
        visible: false,
        captcha_key: '',
        captcha_image: '',
        disabled: false,
    }

    formRef = React.createRef()

    onFinish = async (values) => {
        this.setState({ disabled: true })

        values['captcha_key'] = this.state.captcha_key
        const result = await reqRegister(values)
        if (result.code === 0) {
            message.success('Register success.')
            this.props.history.push('/success/register')
        } else {
            message.error(`Register failed. ${result.message}`)
        }
        
        this.setState({ disabled: false })
    }

    getCaptcha = async () => {
        const captcha_result = await reqCaptcha()
        if (captcha_result.code === 0) {
            const captcha_image = <img src={`data:image/png;base64,${captcha_result.data.captcha_image}`} />
            this.setState({
                captcha_key: captcha_result.data.captcha_key,
                captcha_image: captcha_image
            })
        } else {
            message.error('Get captcha failed.')
        }
    }

    agreementOnClick = (e) => {
        e.preventDefault()
        this.setState({ visible: true })
    }

    render() {
        const formItemLayout = {
            labelCol: {
                span: 6,
            },
            wrapperCol: {
                span: 12,
            },
        }
        
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 12,
                    offset: 0,
                },
                sm: {
                    span: 12,
                    offset: 6,
                },
            },
        }
        

        return (
            <React.Fragment>
                <Row justify="center">
                    <Col>
                        <Title level={3}>User Register</Title>
                    </Col>
                </Row>
                <Row justify="center">
                    <Col span={16}>
                        <Form { ...formItemLayout } 
                            ref={this.formRef} 
                            name="register" 
                            onFinish={this.onFinish} 
                            initialValues={{ agreement: true }}
                            validateTrigger='onSubmit'
                            scrollToFirstError
                        >
                            <Form.Item name="username" label="Username"
                                extra="Spaces are allowed; punctuation is not allowed except for periods, hyphens, apostrophes, and underscores."
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your Username',
                                    },
                                    {
                                        type: 'string'
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item name="email" label="E-mail"
                                extra="A valid e-mail address. All e-mails from the system will be sent to this address. The e-mail address is not made public and will only be used if you wish to receive a new password or wish to receive certain news or notifications by e-mail."
                                rules={[
                                    {
                                        type: 'email',
                                        message: 'The input is not valid E-mail!',
                                    },
                                    {
                                        required: true,
                                        message: 'Please input your E-mail!',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="password"
                                label="Password"
                                extra="Enter at least 8 uppercase/lowercase letters, numbers, or special characters."
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your password!',
                                    },
                                    {
                                        type: 'string',
                                    },
                                    {
                                        min: 8,
                                        max: 16,
                                        whitespace: true,
                                        pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                                        message: 'Letters length should between 8 and 16, with uppercase/lowercase letters, numbers, or special characters.'
                                    }
                                ]}
                                hasFeedback
                            >
                                <Input.Password />
                            </Form.Item>

                            <Form.Item
                                name="confirm_password"
                                label="Confirm Password"
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please confirm your password!',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject('The two passwords that you entered do not match!');
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>
                            <Form.Item name="first_name" label="First name" rules={[{required: true}]}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="last_name" label="Last name" rules={[{required: true}]}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Captcha">
                                <Row gutter={8}>
                                    <Col span={12}>
                                        <Form.Item
                                            name="captcha_value"
                                            noStyle
                                            rules={[{ required: true, message: 'Please input the captcha you got!' }]}
                                        >
                                        <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Space>
                                            <Button onClick={this.getCaptcha}>Get captcha</Button>
                                            {this.state.captcha_image}
                                        </Space>
                                    </Col>
                                </Row>
                            </Form.Item>
                            <Form.Item
                                name="agreement"
                                valuePropName="checked"
                                rules={[
                                    {
                                        validator: (_, value) =>
                                        value ? Promise.resolve() : Promise.reject('Should accept agreement'),
                                    },
                                ]}
                                {...tailFormItemLayout}
                            >
                                <Checkbox>
                                    I have read the <a onClick={this.agreementOnClick}>agreement</a>
                                </Checkbox>
                            </Form.Item>
                            <Form.Item {...tailFormItemLayout}>
                                <Button type="primary" htmlType="submit" disabled={this.state.disabled} className="register-form-button" block>Register</Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <Modal
                    title="User Register Agreement"
                    centered
                    visible={this.state.visible}
                    onOk={() => this.setState({visible: false})}
                    onCancel={() => this.setState({visible: false})}
                    width={1000}
                >
                    <p>some contents...</p>
                    <p>some contents...</p>
                    <p>some contents...</p>
                </Modal>
            </React.Fragment>
        )
    }
}

export default withRouter(Register)